import { ArticleIcon as PhosphorArticleIcon } from "@phosphor-icons/react/dist/ssr/Article";

import { createAppIcon } from "@/components/createAppIcon";

export const ArticleIcon = /* @__PURE__ */ createAppIcon(PhosphorArticleIcon);
